import React from 'react';

import { AppBlock } from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { useFormContext } from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';
import { withAutoScroll } from 'app/developer-v3/components/PartnerSupportForm/components/AutoScroll';

type Service = {
  id: string;
  name: string;
  src: string;
};

type GetHelpAppProps = {
  actions: {
    answer: (data: any) => void;
    unanswer: () => void;
  };
  isCurrent: boolean;
  isRequired: boolean;
  data: any;
  label: string;
  state: string;
  loading: boolean;
  error?: Error;
  services: Service[];
};

const App = (props: GetHelpAppProps) => {
  const {
    actions: { answer, unanswer },
    isCurrent,
    data,
    error,
    isRequired,
    label,
    loading,
    // services, //TODO: remove completely if we use apps from context
    state,
  } = props;

  const { size, setSelectedApp, apps } = useFormContext();

  const formattedApps = apps.map(app => ({
    id: String(app.id),
    name: app.title,
    intention: app.intention,
    isCLIIntegration:
      app && app.implementations[0] ? !app.implementations[0].isUi : undefined,
    src: app.image,
    isBeta: app.isBeta,
    isPublic: app.public,
    isPending: app.pending,
  })) as Service[];

  const appBlockState =
    state === 'confirm' ? state : isCurrent ? 'open' : 'closed';

  return (
    <AppBlock
      apps={formattedApps}
      error={error}
      isLoading={loading}
      isRequired={isRequired}
      onClickEdit={unanswer}
      onSelect={app => {
        answer(app);
        setSelectedApp(app);
      }}
      selectedApp={data}
      size={size}
      state={appBlockState}
      title={label}
    />
  );
};

export default withAutoScroll(App);
